import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
    providedIn: 'root'
})


export class ParticipantsService {

    constructor(private http: HttpClient) { }

    allowToAccess(participantId: number, permission: string, value: boolean) {
        return this.http.post(`recipientroles/${participantId}/access`, {[permission]: value});
    }


    /**
     * Active/Deactive reminder notifications
     * @param role_id 
     * @param status 
     * @returns 
     */
    activeDeactiveReminder(role_id: number, status: boolean){
        return this.http.post(`recipientroles/${role_id}/reminder`, { is_reminder: status });
    }

}